const t = {
  name: "Code3",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.41424 12L10.7071 9.70712L9.29292 8.29291L5.58582 12L9.29292 15.7071L10.7071 14.2929L8.41424 12Z" fill="currentColor"/>
<path d="M13.2928 9.70712L15.5857 12L13.2928 14.2929L14.7071 15.7071L18.4142 12L14.7071 8.29291L13.2928 9.70712Z" fill="currentColor"/>
<path d="M2 5C2 3.34772 3.34772 2 5 2H19C20.6523 2 22 3.34772 22 5V19C22 20.6523 20.6523 22 19 22H5C3.34772 22 2 20.6523 2 19V5ZM5 4C4.45228 4 4 4.45228 4 5V19C4 19.5477 4.45228 20 5 20H19C19.5477 20 20 19.5477 20 19V5C20 4.45228 19.5477 4 19 4H5Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Code3
};
